import { RootState } from '@/redux/store'
import { createSelector } from 'reselect'

const sliceSelectors = {
    licenceId: ({ auth }: RootState) => auth.licenceId,
    licenceName: ({ auth }: RootState) => auth.licenceName,
    deviceId: ({ auth }: RootState) => auth.deviceId,
    profiles: ({ auth }: RootState) => auth.profiles,
    currentProfileUuid: ({ auth }: RootState) => auth.currentProfileUuid,
    completed: ({ auth }: RootState) => auth.completed,
}

export const authSelectors = {
    ...sliceSelectors,
    currentProfile: createSelector(
        [sliceSelectors.profiles, sliceSelectors.currentProfileUuid],
        (profiles, uuid) => {
            if (!profiles) return null

            return profiles.find((profile) => profile.uuid === uuid) ?? null
        }
    ),
}
